export default {
	chat: "Bate-papo",
	do_you_confirm_your_registration_for_the_webinar: "Confirma a sua inscrição para o webinar {title}?",
	do_you_confirm_your_unsubscription_to_the_webinar: "Confirma cancelar a inscrição para o webinar {title}?",
	external_link: "Link externo",
	join_webinar: "Participar do Webinar",
	live: "Ao vivo",
	loading_webinars: "Carregando webinars",
	next: "Próximos",
	no_webinars_are_available_at_the_moment: "Não há webinars disponíveis no momento",
	no_webinars_are_available_with_the_selected_filter: "Não há webinars disponíveis para o filtro selecionado",
	receive_emails_about_this_webinar: "Receber emails sobre esse webinar",
	register_for_the_webinar: "Inscrever-se no webinar",
	subscribe: "Inscrever",
	subscribed: "Inscrito",
	successfully_signed_up_for_the_webinar: "Inscrição feita para o webinar com sucesso",
	training_available_at: "Treinamento disponível em",
	transmission_date: "Data de Transmissão",
	transmission_finished: "Transmissão Finalizada",
	unsubscribe_from_the_webinar: "Cancelar inscrição do webinar",
	unsubscribe_successfully_for_the_webinar: "Inscrição cancelada com sucesso",
	unsubscribe: "Cancelar inscrição",
	watch: "Assistir",
	webinar_offline: "Webinar offline",
	write_your_question: "Escreva sua pergunta",
	your_message_has_been_received_and_is_awaiting_moderation: "Sua mensagem foi recebida e está aguardando moderação",
	your_message_has_been_received: "Sua mensagem foi recebida",
	your_webinar_will_start_soon_please_wait: "Seu webinar irá começar em breve, por favor aguarde"
}